export default {
    'en': 'English',
    'pl': 'Polski',
    'ru': 'Русский',
    'th': 'ไทย',
    'FIWE_FEVER': 'Expo Fever!',
    'EXPERIENCE': 'พบกับประสบการณ์แบบJustfit อุปกรณ์เทคโลโนโลยีระบบEMS ได้ที่งาน',
    'FIWE': 'Asia Fitness Conference',
    'DATE': 'กรุงเทพฯ 11-13 ตุลาคม 2562<br> Justfit บูธ B14',
    'YOUTUBE_TEXT': 'ดูวีดีโอบนยูทูป',
    'SAVE_IT': 'ประหยัดได้ถึง 170.000 บาท เพื่อเดินหน้าธุรกิจอุปกรณ์EMSของคุณแบบก้าวกระโดด',
    'JUSTFIT_LITE_PRICE': 'Justfit Pro+ อุปกรณ์EMSคุณภาพสูงที่มาพร้อมทางเลือกหลากหลาย',
    'CONCEPT': 'ด้วยอุปกรณ์Justfit Pro+ คุณยังจะได้เข้าร่วมโครงการJustfit Mentorship Program ซึ่งจะช่วยให้คุณเข้าถึงธุรกิจJustfit และเข้าถึงการบริการทางเทคนิค',
    'SYSTEM': 'Justfit Pro+ เป็นอุปกรณ์ที่ทำงานด้วยระบบเปิดที่รองรับจำนวนผู้ใช้งานได้มาก นอกจากนี้การเชื่อต่ออุปกรณ์ยังสามารถทำได้ในราคาที่คุ้มค่า',
    'SERVICE': 'พร้อมรับการบริการด้านสินค้าอย่างมีคุณภาพในภาษาไทย',
    'CUSTOMIZED_PRODUCT': 'รับการปรับแต่งอุปกรณ์ได้ตามใจชอบและวางแผนธุรกิจได้ตามต้องการ',
    'APPOINTMENT': 'วางแผนอนาคตและลงทะเบียนเข้ารับประสบการณ์แบบ Justfit ได้ที่งาน Asia Fitness Conference and Expo',
    'INTERESTED': "ใช่ ฉันสนใจ",
    'JUSTFIT_EXPERIENCE': 'พบกับประสบการณ์แบบJustfit ได้ที่งาน Asia Fitness Conference and Expo',
    'TRAININGS': 'เข้าร่วมทดลองอุปกรณ์แบบคนเดียวหรือเป็นกลุ่ม',
    'TRAININGS_TEXT': 'สนใจเข้าร่วมทดลองได้ระหว่างเวลา10.00 - 16.00 ในทุก1ชั่วโมง! ลงทะเบียนด้านล่างได้เลย! ',
    'PRESENTATION': 'สอบถามการสาธิตอุปกรณ์ส่วนตัว',
    'PRESENTATION_TEXT': 'ลงทะเบียนเพื่อเข้าร่วมทดลองอุปกรณ์พร้อมเทรนเนอร์ส่วนตัวและเปิดโอกาศสู่ธุรกิจ',
    'FORM_TITLE': 'รักษาตำแหน่งของคุณ',
    'FORM_TEXT': 'ลงชื่อเข้าร่วมการทดลองใช้อุปกรณ์Justfit หรือเข้ารับการสาธิตอุปกรณ์ส่วนตัวโดยกรอกรายละเอียดด้านล่างแล้วเข้ามาร่วมสนุกกับเราได้ที่บูธ B14',
    'CONTACT_TEXT': 'หากมีข้อสงสัยใดๆ โปรดติดต่อเราได้ที่',
    'YOUR_NAME': 'ชื่อ',
    'EMAIL': 'อีเมล์',
    'MESSAGE': 'ข้อความ',
    'SUBMIT_TEXT': 'ยืนยัน',
	"SENT_FORM": "ขอบคุณสำหรับการลงทะเบียน เราตั้งตารอจะได้เจอคุณ",
    "ERROR_SENT_FORM": "“อีเมล์” ความผิดพลาด”",
    'TRAINING_TYPE': 'ฉันสนใจทดลองอุปกรณ์แบบคนเดียวหรือเป็นกลุ่ม',
    'PRESENTATION_TYPE': 'ฉันสนใจเข้ารับการสาธิตอุปกรณ์ส่วนตัว',
    'PREFERRED_DAY': 'วันทำการ: ',
    'DAY_1': 'วันศุกร์ที่ 11 ตุลาคม 2562',
    'DAY_2': 'วันเสาร์ที่ 12 ตุลาคม 2562',
    'DAY_3': 'วันอาทิตย์ที่ 13 ตุลาคม 2562 ',
    'PREFERRED_TIME': 'เวลาทำการ:',
    'TIME_1': '8.00-11.00 น.',
    'TIME_2': '11.00-14.00 น.',
    'TIME_3': '14.00-18.00 น.',
    'AGREE': '<a class="font-style-italic font-weight-semibold" target="_blank" href="https://justfitart.com/images/privacypolicy.pdf">ฉันได้อ่านและยอมรับเงื่อนไขนโยบายความเป็นส่วนตัว</a>.',
    'YOU_NEED_TO_AGREE': 'You need to agree the privacy policy',
    'LINK_TO_PRODUCT': 'คลิกเพื่อรับส่วนลดสินค้า',
    'JUSTFITPRO_PRICE': 'พบกับอุปกรณ์Justfit Pro+ ในราคาเพียง <span class="font-weight-heavy fs-40">423.000</span>Asia Fitness Conference and Expo <br> <span class="font-weight-normal fs-14">(ประหยัดไปถึง170,000 บาท)</span>',
}
